import { useContext } from "react";
import { SettingContext } from "./App";



const iaam_conf = {
    op_host: process.env.REACT_APP_IAAM_GATEWAY_HOST,
    iaamgw_host: process.env.REACT_APP_IAAM_GATEWAY_HOST, 
    client_id: process.env.REACT_APP_CLIENT_ID,
    post_logout_uri: process.env.REACT_APP_POST_LOGOUT_URL,
    // policyEnforcement: {
    //     aa_host: "https://trbaa.iaam.cloud",
    //     client_name: process.env.REACT_APP_CLIENT_NAME
    // }

}
const iaam = window.iaam;
    
const getDPC = async (prov_code) => {
    let options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json', 
            // 'Authorization': `bearer ${access_token}`
        }
    }
    const data = await fetch(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_MASTER_PREFIX}/dpc/get_dpc_with_prov_code?prov_code=${prov_code}`, options);
    const json = await data.json()
    return json
}

const getApps = async (inum, access_token) => {
    let options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json', 
            'Authorization': `bearer ${access_token}`
        }
    }
    const data = await fetch(`${process.env.REACT_APP_IAAMREG_HOST}/iaam-api/applications?inum=${inum}&app_type=WEB`, options);
    const json = await data.json()
    let apps = json.filter((item) => {return item.client_name !== process.env.REACT_APP_CLIENT_NAME? true : false})
    return apps.map((item) => {return {...item, client_name:item.client_name.split("-").join(" ")}})
}

const IAAMLogin = () => {
    const { dispatch } = useContext(SettingContext);
    iaam.initLoginFlow(iaam_conf)
    .then((init) => {
        iaam.isLoggedIn(async (error, status)=>{
            if(!status){
                iaam.login()
            }
            else{
                // const permission = await iaam.policyEnforcement();
                // console.log(permission)
                iaam.getProfile(async (err, profile) => {  
                    if(!err){
                        iaam.getAccessToken(async (err, access_token) => {
                            if (!err) {
                                let dpc = await getDPC(profile.province_code)
                                profile["dpc_code"] = dpc.health_region_code
                                profile["dpc_name"] = dpc.health_region_name

                                let apps = await getApps(profile.inum, access_token)
                                profile["apps"] = apps

                                dispatch({
                                    type: "LOGIN",
                                    iaam: iaam,
                                    profile: profile,
                                    // isPermited: permission.decision.toUpperCase() === "PERMIT",
                                })
                            }
                            else{
                                iaam.login()
                            }
                        })
                        
                    }
                    else{
                        
                    }
                })
                
            }
        })
    })
    return (<></>)
}

export default IAAMLogin